import { makeStyles } from "@material-ui/styles";

export const useStyles = makeStyles({
  card: {
    marginBottom: '1rem',
  },
  title: {
    fontSize: '1.6rem',
  },
  media: {
    maxHeight: "7rem",
  },
  link: {
    textDecoration: "none",
    color: "inherit",
  },
});